import { createWebHistory, createRouter } from "vue-router";

import ProjectOverview from "@/views/ProjectOverview.vue";
import ContactDetails from "@/views/ContactDetails.vue";
import Imprint from "@/components/ImprintView.vue";
import DataPrivacy from "@/components/DataPrivacy.vue";
import Disclaimer from "@/components/DisclaimerView.vue";
import License from "@/components/LicenseView.vue"

const routes = [
    {
        path: '/',
        name: "Project Overview",
        component: ProjectOverview,
    },
    {
        path: '/contact',
        name: 'Contact',
        component: ContactDetails,
    },
    {
        path: '/imprint',
        name: 'Imprint',
        component: Imprint,
    },
    {
        path: '/data-privacy',
        name: 'DataPrivacy',
        component: DataPrivacy,
    },
    {
        path: '/disclaimer',
        name: 'Disclaimer',
        component: Disclaimer,
    },
    {
        path: '/license',
        name: 'License',
        component: License,
    }
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
})

export default router;